/** Port Townsend Middle School local parts look like `31a.taylor`: class digits, first initial, last name. */

const SCHOOL_LOCAL = /^(\d+)([a-z])\.([a-z]+(?:['’-][a-z]+)*)$/i;

export interface SchoolEmailNameGuess {
  givenName: string;
  familyName: string;
}

function titleCaseName(raw: string): string {
  return raw.replace(/[a-z]+/gi, (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());
}

export function emailLocalPart(email: string): string {
  const at = email.indexOf("@");
  return at > 0 ? email.slice(0, at) : email;
}

/** Prefill only. Does not mean a name has been saved. */
export function guessNameFromSchoolEmail(email: string): SchoolEmailNameGuess | null {
  const match = SCHOOL_LOCAL.exec(emailLocalPart(email).trim());
  if (!match) return null;
  const initial = match[2];
  const family = match[3];
  if (!initial || !family) return null;
  return {
    givenName: initial.toUpperCase(),
    familyName: titleCaseName(family),
  };
}
